export function BackgroundGradient() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      <div className="absolute -bottom-32 -left-32 w-[600px] h-[600px] bg-gradient-to-tr from-[#01B9D9]/20 via-[#01B9D9]/5 to-transparent blur-3xl" />
      <div className="absolute -bottom-32 -right-32 w-[600px] h-[600px] bg-gradient-to-tl from-[#F6C768]/20 via-[#F6C768]/5 to-transparent blur-3xl" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-gradient-to-t from-[#EB7138]/15 via-transparent to-transparent blur-3xl" />
    </div>
  );
}